import React, { lazy } from 'react';
import { FadeInUp } from './FadeInUp';
export function AgitationSection() {
  return <section className="relative py-10 md:py-14 px-5 overflow-hidden bg-slate-dark" data-id="element-19">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-20">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-dark/80 via-slate-dark/90 to-slate-dark" data-id="element-21"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-22">
        <FadeInUp data-id="element-23">
          <p className="text-2xl md:text-4xl font-serif font-bold text-pure-white leading-relaxed md:leading-normal pt-[0px] pb-[0px]" data-id="element-24">
            "Son las 2:00 AM. Escuchas el primer ladrido. Sabes lo que viene
            después. No puedes dormir, tus vecinos están perdiendo la paciencia
            y sientes que tu perro sufre cada segundo.{' '}
            <span className="text-red-400" data-id="element-25">¿Ese momento de impotencia?</span>{' '}
            Nos aseguraremos de que no vuelva a ocurrir jamás."
          </p>
        </FadeInUp>
      </div>
    </section>;
}